export const DEFAULT_FORM_NAME = 'Unnamed form';
